import Button from "../components/button/Button"
import FAQItem from "../components/questions/Questions"
import styles from "./ForthScreen.module.css"

const ForthScreen = () => {
    return <>
        <div className={styles.title}>אתן שואלות , אני עונה</div>
        
        <FAQItem 
            question="איך אני יכולה להיות בטוחה שאקבל את המראה המושלם ליום החתונה שלי?" 
            answer="אני מבין לחלוטין את החשש שלך, לכן אני מקפיד לקיים פגישת ייעוץ חודש לפני החתונה עבור האיפור והשיער כדי שנרד לפרטים הכי קטנים ונדייק הכל ליום הגדול "
        />

        <FAQItem 
            question="איך אוכל להיות בטוחה שהאיפור יחזיק לאורך כל היום?" 
            answer="אני משתמש בטכניקות מקצועיות ובמוצרים עמידים במיוחד שמותאמים ספציפית לאירועים ארוכים. האיפור שאני מבצע מתוכנן להחזיק מתחילת היום ועד סופו, כולל במהלך הצילומים, החופה והריקודים. בנוסף, אני מעניק טיפים לרענון קל במידת הצורך במהלך האירוע."
        />

        <FAQItem 
            question="האם אתה מגיע לאזור ההתארגנות?" 
            answer="כן, אני מגיע לכל מקום התארגנות שתבחרי. אני מביא איתי את כל הציוד הנדרש כדי להבטיח שתקבלי את השירות המושלם בסביבה הנוחה לך."
        />

        <FAQItem 
            question="האם אתה מאפר גם את המלוות?" 
            answer="יש אופציה לאיפור של 2 מלוות (בתיאום מראש ובתשלום נוסף) כי אני מעדיף תמיד להתמקד אך ורק בכלה כדי להעניק לך את מלוא תשומת הלב והזמן שאת צריכה ביום המיוחד שלך."
        />

        <FAQItem 
            question="מה לגבי תסרוקת שנייה במהלך החתונה?" 
            answer="כן, אני מציע שירות של תסרוקת שנייה במהלך האירוע. זה מאפשר לך לרענן את המראה שלך ולשנות את הסטיילינג לקראת הערב או הריקודים."
        />

        <FAQItem 
            question="אני חוששת שהאיפור יהיה כבד מדי או גס מדי. איך אתה מתמודד עם זה?" 
            answer="אני שם דגש על תהליך העבודה איתי כי הוא מבהיר לי בדיוק מה את מחפשת ורוצה כדי שתצאי עם האיפור הכי מושלם בשבילך ביום החתונה! במהלך הייעוץ נוכל לדון בדיוק ברמת הכיסוי והעוצמה שאת מעדיפה, ואני אתאים את הטכניקה והמוצרים בהתאם. המטרה שלי היא שתרגישי הכי את! רק בגרסה משודרגת יותר."
        />

        <FAQItem 
            question="איך אוכל להיות בטוחה שהשיער יחזיק לאורך כל האירוע?" 
            answer="אני משתמש בטכניקות מקצועיות ובמוצרי שיער איכותיים שמבטיחים עמידות לאורך זמן. התסרוקת מתוכננת כך שתחזיק מעמד גם בתנאי מזג אוויר שונים ובמהלך הריקודים . בנוסף, אני מציע שירות של תסרוקת שנייה במהלך האירוע לרענון המראה ואפילו תוספות שיער במידת הצורך."
        />
<Button text="עמנואל, בוא נדבר!"/>
    </>
}

export default ForthScreen